// js
import Overview from '../../components/analytics/Overview';
import { connect } from 'react-redux';
import { makeGetTotalSourcesStats, makeGetAllAreasSourcesStats } from '../../selectors/analytics/overviewSelectors';


const mapStateToProps = (state, props) => {
  const getTotalSourcesStats = makeGetTotalSourcesStats();
  const getAllAreasSourcesStats = makeGetAllAreasSourcesStats();

  return {
    totalStats: getTotalSourcesStats(state, props),
    areaStats: getAllAreasSourcesStats(state, props)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);



// WEBPACK FOOTER //
// ./src/containers/analytics/Overview.js